<!-- 車両一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-truck
          </v-icon>
          車両
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-right">
        <template
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-btn
            color="info"
            @click="exportButtonClickEvent"
          >
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
          </v-btn>
          &nbsp;
          <v-btn
            color="info"
            @click="importButtonClickEvent"
          >
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
          </v-btn>
        </template>
        <template
          v-else
        >
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                dark
                v-bind="attrs"
                v-on="on"
              >
                CSVファイル
                <v-icon small>
                  mdi-file-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="exportButtonClickEvent"
              >
                <v-list-item-title>
                  CSV出力
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="importButtonClickEvent"
              >
                <v-list-item-title>
                  CSV取込
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        &emsp;
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          車両の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-data-table
            :headers="tableHeaders"
            :items="vehicles"
            disable-pagination
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>編集</span>
              </v-btn>

              <v-btn
                v-if="item.editable"
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="deleteButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-trash-can-outline
                </v-icon>
                <span v-else>削除</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <vehicle-register-dialog
      :enable-dialog="enableVehicleDialog"
      :target-id="targetId"
      @closeEvent="closeVehicleDialog"
      @registerEvent="vehicleCallback"
    />
    <!-- ダイアログ -->

    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import VehicleRegisterDialog from './dialogs/VehicleRegistDialog'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: 'DriverMasterVehicleIndex',
  components: { CustomPagination, Confirm, VehicleRegisterDialog },
  mixins: [
    DownloadMixin
  ],
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      targetId: null,
      enableVehicleDialog: false,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '車両名', value: 'name' },
        { text: '車両番号', value: 'number' },
        { value: 'sort_priority', text: '表示順', align: 'right' },
        { value: 'created_at', text: 'データ作成日時' },
        { value: 'updated_at', text: 'データ更新日時' },
        { text: '編集/削除', value: 'editable', align: 'end' },
      ],
      vehicles: []
    }
  },
  computed: {
    ...mapState('DriverMasterVehicle', {
      searchCondition: 'condition',
      pagination: 'pagination'
    }),
    ...mapGetters('DriverMasterVehicle', [
      'hasResult'
    ]),
  },
  watch: {
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchVehicles()
  },
  methods: {
    ...mapActions('DriverMasterVehicle', {
      fetchVehicles: 'index',
      deleteVehicle: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    ...mapActions('DriverSettingVehicle', {
      download: 'index',
    }),

    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.targetId = null
      this.enableVehicleDialog = true
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.targetId = item.id
      this.enableVehicleDialog = true
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteVehicle({ id: item.id }).then(() =>{
            this.searchVehicles()
          })
        }
      })
    },
    importButtonClickEvent() {
      this.$router.push({name: 'DriverMasterVehicleCsvImport'})
    },
    exportButtonClickEvent () {
      this.download().then((content) => {
        this.downloadCsv(content, '車両')
      })
    },
    /**
     * モーダルを閉じる
     */
    closeVehicleDialog () {
      this.enableVehicleDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    vehicleCallback () {
      this.closeVehicleDialog()
      this.searchVehicles()
    },
    changePage(page) {
      this.page = page;
      this.searchVehicles()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchVehicles()
    },
     /**
     * 車両検索
     */
    searchVehicles () {
      let params = {
        page: this.page,
        limit: this.perPage,
      }
      this.fetchVehicles(params).then((content) => {
        this.vehicles = content.vehicles
      })
    },
  }
}
</script>

<style scoped>

</style>
